import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { memo } from 'react';
import { Popup } from 'react-leaflet';
import { dictionary } from '../../../../../lang';
const HeatMapCellDetails = ({ qualifiedAddresses, weeksSinceKnocked, pinsScore, }) => {
    const cellDetails = [
        { label: dictionary.QUALIFIED_ADDRESSES, value: qualifiedAddresses },
        { label: dictionary.WEEKS_SINCE_KNOCKED, value: weeksSinceKnocked },
        { label: dictionary.PIN_SCORE, value: pinsScore },
    ];
    return (_jsx(Popup, { children: _jsx("ul", { children: cellDetails.map(({ label, value }) => (_jsxs("li", { className: "flex items-center justify-between gap-x-4 border-b last:border-none", children: [_jsx("p", { className: "text-sm text-gray-500", children: label }), _jsx("span", { className: "text-sm", children: value ?? 0 })] }, label))) }) }));
};
HeatMapCellDetails.propTypes = {
    qualifiedAddresses: PropTypes.number,
    weeksSinceKnocked: PropTypes.number,
    pinsScore: PropTypes.number,
};
export default memo(HeatMapCellDetails);
